import { debugAction } from '../utils/index';
import { company, companyReducer } from './company';
import { jobs, jobsReducer } from './jobs';
import { pipeline, pipelineReducer } from './pipeline';
import { token, tokenReducer } from './token';
import { user, userReducer } from './user';

export const initialState = {
  user,
  token,
  pipeline,
  company,
  jobs
};

export function combinedReducers(state = initialState, action) {
  debugAction(action);
  return {
    ...state,
    user: userReducer(state.user, action),
    token: tokenReducer(state.token, action),
    pipeline: pipelineReducer(state.pipeline, action),
    company: companyReducer(state.company, action),
    jobs: jobsReducer(state.jobs, action)
  };
}
